import script from "./MyMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMessage.vue?vue&type=script&setup=true&lang=js"

import "./MyMessage.vue?vue&type=style&index=0&id=04f24e6c&scoped=true&lang=css"

import exportComponent from "D:\\nmgxt\\xaskFront\\branch\\suin\\cms_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f24e6c"]])

export default __exports__